import React, {useCallback, useState} from "react"
import ReactHeight from "react-height"

import {WellnessMediaCategory} from "@irati/types"
import Tag from "@irati/ui/src/Tag"
import {StyledCategoryContainer} from "./styled"
import {WELLNESS_MEDIA_ALL_CATEGORY} from "./WellnessCategoryList"

interface Props {
  data: WellnessMediaCategory[]
  isShowingMore: boolean
  handleCategoryClick: (uuid: string, name: string) => void
  displayShowMoreText: boolean
  shouldDisplayShowMoreText: () => void
  selectedCategoryIds?: string[]
}

export const WellnessCategories: React.FC<Props> = ({
  data,
  isShowingMore,
  handleCategoryClick,
  displayShowMoreText,
  shouldDisplayShowMoreText,
  selectedCategoryIds
}) => {
  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth <= 768)

  const onHeightReady = useCallback(
    (height: number) => {
      if (!displayShowMoreText && height > 60) {
        shouldDisplayShowMoreText()
      }
    },
    [displayShowMoreText, shouldDisplayShowMoreText]
  )

  const maxVisible = isMobile ? 1 : 6
  const visibleCategories = displayShowMoreText && !isShowingMore ? data.slice(0, maxVisible) : data

  return (
    <ReactHeight onHeightReady={onHeightReady}>
      <StyledCategoryContainer displayShowMoreText={displayShowMoreText} isShowingMore={isShowingMore}>
        {visibleCategories.map((category) => {
          const isSelected = selectedCategoryIds
            ? category?.id === WELLNESS_MEDIA_ALL_CATEGORY.id
              ? selectedCategoryIds.length === 0
              : selectedCategoryIds.includes(category?.uuid || category?.id)
            : false

          return (
            <Tag
              key={category?.uuid}
              name={category?.name}
              count={category?.count}
              selected={isSelected}
              onClick={() => handleCategoryClick(category?.uuid || category?.id, category?.name)}
              isWellness={true}
            />
          )
        })}
      </StyledCategoryContainer>
    </ReactHeight>
  )
}
